import {JournalCard} from './JournalCard';
export default JournalCard;
